// extracted by css-extract-rspack-plugin
export default {"divider":"divider--dfnF8ZBGoiAewBCx"};